import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, SendIcon, ExternalLinkIcon } from 'lucide-react';
import { PageShell } from '../components/layout/PageShell';
import { GlassCard } from '../components/ui/GlassCard';
import { Button } from '../components/ui/Button';
import { useI18n } from '../lib/i18n';
import { CONTACT } from '../lib/data';
export function Contact() {
  const {
    t,
    lang
  } = useI18n();
  const [sent, setSent] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSent(true);
  };
  const inputClass = 'w-full rounded-lg border border-[rgba(217,217,217,0.2)] bg-[rgba(217,217,217,0.05)] px-4 py-2.5 text-white placeholder-silver/40 focus:border-neon focus:outline-none focus:ring-1 focus:ring-neon';
  return <PageShell data-id="element-235" data-mp="f9o5n9kjtcog">
      <section className="mx-auto max-w-container px-4 py-12 sm:px-6" data-id="element-236" data-mp="f964byj1489o">
        <h1 className="text-3xl font-extrabold text-white sm:text-4xl" data-id="element-237" data-mp="abd1nfgxpwe5">
          {t('contact_title')}
        </h1>

        <div className="mt-8 grid gap-6 lg:grid-cols-2" data-id="element-238" data-mp="15g8dh5cw3csh">
          {/* Info */}
          <div className="space-y-6" data-id="element-239" data-mp="19gs7i02620ae">
            <GlassCard data-id="element-240" data-mp="19fphrvgky3w2">
              <ul className="space-y-4 text-sm" data-id="element-241" data-mp="19exmklqwa86b">
                {CONTACT.phones.map(p => <li key={p} className="flex items-center gap-3 text-silver/85" data-id="element-242" data-mp="1e9ts8op20u1w">
                    <PhoneIcon className="h-4 w-4 text-neon" data-id="element-243" data-mp="mh2s43492l7d" />
                    <a href={`tel:${p}`} className="hover:text-white" data-id="element-244" data-mp="minlhpetvy3n">
                      {p}
                    </a>
                  </li>)}
                {CONTACT.emails.map(e => <li key={e} className="flex items-center gap-3 text-silver/85" data-id="element-245" data-mp="vjlrgd8tufov">
                    <MailIcon className="h-4 w-4 text-neon" data-id="element-246" data-mp="26vcvok3f0p6b" />
                    <a href={`mailto:${e}`} className="hover:text-white" data-id="element-247" data-mp="2bviq2812kps3">
                      {e}
                    </a>
                  </li>)}
                <li className="flex items-center gap-3 text-silver/85" data-id="element-248" data-mp="1m5sjvvzqmalq">
                  <MapPinIcon className="h-4 w-4 text-neon" data-id="element-249" data-mp="1h78utmpukip5" />
                  <a href={CONTACT.addressUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 hover:text-white" data-id="element-250" data-mp="1w5jahml6g5gj">
                    Addis Ababa, Ethiopia
                    <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-251" data-mp="13ejadmpyvlu5" />
                  </a>
                </li>
                <li className="flex items-center gap-3 text-silver/85" data-id="element-252" data-mp="1d6oygld3lj42">
                  <ClockIcon className="h-4 w-4 text-neon" data-id="element-253" data-mp="1d8046qq3t0xt" />
                  {t('hours')}
                </li>
              </ul>
            </GlassCard>

            <GlassCard data-id="element-254" data-mp="kpkwd4b56t8g">
              <h2 className="mb-4 text-lg font-semibold text-white" data-id="element-255" data-mp="kotdmu2n8pzl">
                {t('connect_with_us')}
              </h2>
              <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-256" data-mp="fp6xabriqtmk">
                {[{
                label: 'Linktree',
                href: CONTACT.linktree
              }, {
                label: 'Telegram',
                href: CONTACT.telegramChannel
              }, {
                label: 'Facebook',
                href: CONTACT.facebook
              }, {
                label: 'TikTok',
                href: CONTACT.tiktok
              }, {
                label: 'Instagram',
                href: CONTACT.instagram
              }, {
                label: 'LinkedIn',
                href: CONTACT.linkedin
              }, {
                label: 'Website',
                href: CONTACT.website
              }, {
                label: 'Support Bot',
                href: CONTACT.supportBot
              }].map(l => <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-between rounded-lg border border-[rgba(217,217,217,0.15)] px-3 py-2 text-silver/80 hover:border-neon hover:text-neon" data-id="element-257" data-mp="257asyzxj5my5">
                    {l.label}
                    <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-258" data-mp="2ny1w3jqxch43" />
                  </a>)}
              </div>
            </GlassCard>
          </div>

          {/* Form */}
          <GlassCard data-id="element-259" data-mp="2j0jyuqm9rqbx">
            {sent ? <div className="flex h-full flex-col items-center justify-center py-10 text-center" data-id="element-260" data-mp="2ew2f2rfwtd15">
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[rgba(74,222,128,0.12)]" data-id="element-261" data-mp="17klgfw57bry1">
                  <SendIcon className="h-6 w-6 text-[#4ADE80]" data-id="element-262" data-mp="13gdrpyyqubzt" />
                </div>
                <p className="mt-4 text-lg font-medium text-white" data-id="element-263" data-mp="3f6ll6qz6f0r9">
                  {t('message_sent')}
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-264" data-mp="3o68mlcrwo6kb">
                <div data-id="element-265" data-mp="3o3vw2b830nvn">
                  <label htmlFor="name" className="mb-1.5 block text-sm text-silver/80" data-id="element-266" data-mp="3swp1l1bdk08s">
                    {t('name')} <span className="text-neon" data-id="element-267" data-mp="1pw52arj0pal">*</span>
                  </label>
                  <input id="name" required className={inputClass} data-id="element-268" data-mp="6o5xweps3dt1" />
                </div>
                <div data-id="element-269" data-mp="as5aim7xtsh4">
                  <label htmlFor="email" className="mb-1.5 block text-sm text-silver/80" data-id="element-270" data-mp="arlrf26jwy1i">
                    {t('email')} <span className="text-neon" data-id="element-271" data-mp="2cj8n3h1e1h4b">*</span>
                  </label>
                  <input id="email" type="email" required className={inputClass} data-id="element-272" data-mp="2hha4lxj618do" />
                </div>
                <div data-id="element-273" data-mp="3ftmhm2taf0nm">
                  <label htmlFor="phone" className="mb-1.5 block text-sm text-silver/80" data-id="element-274" data-mp="3fu4i5bmzg11c">
                    {t('phone')}
                  </label>
                  <input id="phone" type="tel" className={inputClass} data-id="element-275" data-mp="3oszuz6kj89dm" />
                </div>
                <div data-id="element-276" data-mp="7kw0czc6q8a1">
                  <label htmlFor="subject" className="mb-1.5 block text-sm text-silver/80" data-id="element-277" data-mp="7kctqerzj6bb">
                    {t('subject')} <span className="text-neon" data-id="element-278" data-mp="gehfwkw6btki">*</span>
                  </label>
                  <input id="subject" required className={inputClass} data-id="element-279" data-mp="ccw8hf2es7hp" />
                </div>
                <div data-id="element-280" data-mp="qc5mc8356pii">
                  <label htmlFor="message" className="mb-1.5 block text-sm text-silver/80" data-id="element-281" data-mp="qbm4sshem350">
                    {t('message')} <span className="text-neon" data-id="element-282" data-mp="14z4anu6pd3t0">*</span>
                  </label>
                  <textarea id="message" rows={4} required className={inputClass} data-id="element-283" data-mp="14x19qf40hq9i" />
                </div>
                <Button type="submit" pulse fullWidth data-id="element-284" data-mp="v311i4dfo4wk">
                  <SendIcon className="h-4 w-4" data-id="element-285" data-mp="zyzu645so92s" />
                  {t('send_message')}
                </Button>
              </form>}
          </GlassCard>
        </div>
      </section>
    </PageShell>;
}